import React from 'react';
import { Box, Checkbox, Tooltip, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

export default function RecordActionCheckbox({
  label,
  checked,
  disabled = false,
  warningTooltip,
  ariaLabel,
  onChange,
  styles,
}) {
  const checkbox = (
    <Checkbox
      size="small"
      checked={Boolean(checked)}
      disabled={disabled}
      onChange={(event) => onChange?.(event.target.checked)}
      inputProps={{ 'aria-label': ariaLabel || label }}
      sx={styles?.permissionMatrixCheckbox}
    />
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minHeight: 32 }}>
      {checkbox}
      <Typography variant="body2" sx={{ flex: 1 }}>
        {label}
      </Typography>
      {warningTooltip ? (
        <Tooltip title={warningTooltip} arrow>
          <WarningAmberOutlinedIcon sx={{ fontSize: 16, color: 'warning.main' }} />
        </Tooltip>
      ) : null}
    </Box>
  );
}
